import { ACTION_STEPS, STEPS } from '@/components/ShowModal/config';

export default {
    /**
     * Gets the list of steps.
     *
     * @param {object} state Vuex state.
     * @returns {string[]} Steps.
     */
    steps(state) {
        return ACTION_STEPS[state.action] ?? [];
    },

    /**
     * Gets the steps count.
     *
     * @param {object} _state Vuex state.
     * @param {object} getters Vuex getters.
     * @returns {number} Steps count.
     */
    stepsCount(_state, getters) {
        const stepsCount = getters.steps.length;

        if (getters.skipTrial && getters.steps.includes(STEPS.TRIAL)) {
            return stepsCount - 1;
        }

        return stepsCount;
    },

    /**
     * Gets the step name by its index.
     *
     * @param {object} _state Vuex state.
     * @param {object} getters Vuex getters.
     * @returns {string}         Step name.
     */
    step: (_state, getters) => (stepIndex) => {
        return getters.steps[stepIndex];
    },

    /**
     * Gets the current step index.
     *
     * @param {object} state Vuex state.
     * @param {object} getters Vuex getters.
     * @returns {number} Step index.
     */
    stepIndex(state, getters) {
        return getters.steps.findIndex((_step) => _step === state.step);
    },

    /**
     * Indicates whether trial step should be skipped.
     *
     * @param {object} _state Vuex state.
     * @param {object} _getters Vuex getters.
     * @param {object} rootState Vuex root state.
     * @returns {boolean}           Check result.
     */
    skipTrial(_state, _getters, rootState) {
        return !! rootState.currentSubscription;
    },
};
